import React, { useEffect, useState } from 'react';
import { Box, FormControl, TextField, Button } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import IconButton from '@material-ui/core/IconButton';
import ClearIcon from '@material-ui/icons/Clear';
import SearchIcon from '@material-ui/icons/Search';
import ReplayIcon from '@material-ui/icons/Replay';
import DateRangePickerML from '@/components/DateRangePickerML';
import { SelectFieldCom } from '@/components/FormType';
import SearchGroupStyled from './SearchGroupStyled';

const SearchGroup = (props) => {
  const { query, handleRestClick, handleSearch } = props;
  const { taskName, status, startDate, endDate } = query;
  //查询参数
  const { handleSubmit, control, setValue, getValues, watch } = useForm({
    defaultValues: { taskName, status, date: { startDate, endDate } },
  });
  // const [isClick, setIsClick] = useState(false);
  const statusData = [
    { value: '0', name: '处理中' },
    { value: '1', name: '已完成' },
    { value: '2', name: '处理失败' },
  ];
  const [isReset, setIsReset] = useState(false);
  useEffect(() => {
    if (taskName) {
      setValue('taskName', taskName);
    }
    if (status) {
      setValue('status', status);
    }
  }, [taskName, status, setValue]);

  //重置
  const handleReset = () => {
    setValue('taskName', '');
    setValue('status', '');
    setValue('date', {
      startDate: null,
      endDate: null,
    });
    setIsReset(true);

    handleRestClick({
      taskName: '',
      status: '',
      startDate: null,
      endDate: null,
    });
  };
  return (
    <SearchGroupStyled>
      <form
        onSubmit={handleSubmit((values) => {
          const { date, ...rest } = values;
          handleSearch({
            ...rest,
            startDate: date?.startDate,
            endDate: date?.endDate,
          });
        })}
      >
        <Box className="search-wrapper">
          <Box className="left">
            <Box className="first-line">
              <Controller
                render={(rp) => (
                  <TextField
                    name="taskName"
                    control={control}
                    id="basic"
                    variant="standard"
                    className="input"
                    label="任务名称"
                    value={rp.value}
                    defaultValue={''}
                    onChange={(e) => {
                      setValue('taskName', e.target.value);
                    }}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          <IconButton
                            className="clear-btn"
                            onClick={() => {
                              setValue('taskName', '');
                            }}
                            edge="end"
                          >
                            {rp.value ? (
                              <ClearIcon className="clear-icon" />
                            ) : (
                              ''
                            )}
                          </IconButton>
                        </InputAdornment>
                      ),
                    }}
                  />
                )}
                name="taskName"
                control={control}
                id="basic"
                variant="standard"
                className="input"
                label="任务名称"
              />
              <SelectFieldCom
                control={control}
                getValues={getValues}
                setValue={setValue}
                watchAllFields={watch()}
                name="status"
                label="状态"
                typeList={statusData}
              />
              <FormControl variant="standard">
                <Controller
                  render={(rp) => (
                    <DateRangePickerML
                      label="创建时间"
                      startText="创建开始时间"
                      endText="创建结束时间"
                      defaultStartDate={startDate || null}
                      defaultEndDate={endDate || null}
                      rp={rp}
                      setValue={setValue}
                      onChange={() =>
                        // {
                        //  startDate, endDate, reset
                        //  }
                        {
                          setIsReset(false);
                        }
                      }
                      // name="custom-form-submit-name"
                      isReset={isReset}
                    />
                  )}
                  name="date"
                  control={control}
                />
              </FormControl>
              <div></div>
            </Box>
          </Box>
          <Box className="button-group">
            <Button
              variant="contained"
              color="secondary"
              className="reset"
              onClick={handleReset}
              startIcon={<ReplayIcon sx={{ width: '16px', height: '16px' }} />}
            >
              重置
            </Button>

            <Button
              variant="contained"
              type="submit"
              className="search"
              startIcon={<SearchIcon sx={{ width: '16px', height: '16px' }} />}
            >
              查询
            </Button>
          </Box>
        </Box>
      </form>
    </SearchGroupStyled>
  );
};
export default SearchGroup;
